// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-upgrade-root[data-v-f0ee844e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 32px;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.hideCode_table[data-v-f0ee844e] table th {\n  width: 50%;\n}", ""]);
// Exports
module.exports = exports;
